// Which of the site's languages a visitor should be reading.
//
// Its own module because it is the one rule on this page worth pinning: a
// redirect that guesses wrong sends somebody to a page they did not ask for, and
// the ordering between the three signals is not obvious from either of them. The
// module holds the RULE and nothing else - the DOM reading, the storage and the
// `location.replace` stay in main.ts, so this can be exercised without a page.
//
// The clock-and-browser half is the platform's, not the site's: the panels start
// in a language by the same rule (@edtechcore/i18n/place), so a visitor this
// page sends to Ukrainian is not met by an English sign-in one click later.

import { preferredLanguage, type OfferedLanguage } from '@edtechcore/i18n/place';

export { HOME_ZONES, preferredLanguage, type OfferedLanguage } from '@edtechcore/i18n/place';

/**
 * The address to move an arriving visitor to, or nothing to leave them where
 * they are.
 *
 * `stored` is the language they picked once, and it outranks both other signals:
 * it is the only one they made on purpose, and it is HONOURED rather than merely
 * obeyed as a veto - somebody who picked Polish and later types the bare domain
 * arrives in Polish. A choice of the page already on screen resolves to nothing,
 * which is what keeps the switcher's link to this very page from being a loop.
 */
export function languageToOpen<T extends OfferedLanguage>(
  offered: T[],
  documentLang: string,
  stored: string | null,
  zone: string,
  languages: readonly string[],
): T | undefined {
  const wanted = stored ? offered.find((link) => link.lang === stored) : preferredLanguage(offered, zone, languages);
  return wanted && wanted.lang !== documentLang ? wanted : undefined;
}
